import { envConfigs } from '..';

export const localeNames: any = {
  en: 'English',
  zh: '中文',
  es: 'Español',
  pt: 'Português',
  de: 'Deutsch'
};

export const locales = ['en', 'zh', 'es','pt','de'];

export const defaultLocale = envConfigs.locale;

export const localePrefix = 'as-needed';

export const localeDetection = false;

export const localeMessagesRootPath = '@/config/locale/messages';

export const localeMessagesPaths = [
  'common',
  'landing',
  'blog',
  'pricing',
  'settings/sidebar',
  'settings/profile',
  'settings/security',
  'settings/billing',
  'settings/payments',
  'settings/credits',
  'settings/apikeys',
  'settings/checkin',
  'admin/sidebar',
  'admin/users',
  'admin/roles',
  'admin/permissions',
  'admin/categories',
  'admin/posts',
  'admin/payments',
  'admin/subscriptions',
  'admin/credits',
  'admin/settings',
  'admin/apikeys',
  'admin/ai-tasks',
  'admin/chats',
  'ai/music',
  'ai/chat',
  'ai/image',
  'ai/video',
  'photo-effects/common',
  'photo-effects/ghibli',
  'photo-effects/pixar',
  'photo-effects/pixel',
  'photo-effects/rick-and-morty',
  'photo-effects/y2k-style',
  'photo-effects/pop-art',
  'photo-effects/electric-graffiti',
  'photo-effects/action-figure',
  'photo-effects/gta',
  'photo-effects/vector-art',
  'photo-effects/photo-to-painting',
  'photo-effects/ai-christmas-generator',
  'photo-effects/ai-digital-art',
  'photo-effects/ai-minecraft-generator',
  'photo-effects/ai-puppet',
  'photo-effects/ai-pet-birthday',
  'photo-effects/background-remover',
  'photo-effects/ai-pet-meme',
  'photo-effects/ai-christmas-elf',
  'photo-effects/3d-dartoon-keychain',
  'photo-effects/ai-nintendo',
  'photo-effects/ai-poster-effects',
  'photo-effects/old-photo-restoration',
  'photo-effects/face-swap',
  'photo-effects/image-upscaler',
  'lp/ai-art-generator',
  'lp/image-to-image-ai',
  'ai-image-editor/ai-image-editor',
  'ai-image-upscaler/ai-image-upscaler',
  'ai-image-enhancer/ai-image-enhancer',
  'background-remover/background-remover',
  'ai-old-photo-restoration/ai-old-photo-restoration',
  'ai-face-swap/ai-face-swap',
  'video-effects',
  'common/announcement',
  'common/checkin-button',
  'video-effects/common',
  'video-effects/christmas',
  'video-effects/christmas-cozy',
  'activity/sidebar',
  'activity/ai-tasks',
  'activity/chats',
];
